import { render } from "./PrenotazioniDataTable.vue?vue&type=template&id=9c685a34"
import script from "./PrenotazioniDataTable.vue?vue&type=script&lang=js"
export * from "./PrenotazioniDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__